import { createContext, type FC, type PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { DEFAULT_MODULE, MODULE_STORAGE_KEY } from './ModuleFilter.constants';
import type { IModuleFilterProvider } from './ModuleFilter.types';

export const ModuleFilterContext = createContext<IModuleFilterProvider | undefined>(undefined);

const readStoredModule = (): string => {
	try {
		return window.localStorage.getItem(MODULE_STORAGE_KEY) || DEFAULT_MODULE;
	} catch {
		return DEFAULT_MODULE;
	}
};

const ModuleFilterProvider: FC<PropsWithChildren> = ({ children }) => {
	const [selectedModule, setSelectedModuleState] = useState<string>(readStoredModule);

	const setSelectedModule = useCallback((moduleName: string) => {
		setSelectedModuleState(moduleName);
		try {
			window.localStorage.setItem(MODULE_STORAGE_KEY, moduleName);
		} catch {
			// Storage unavailable (private mode): the selection still works in-memory.
		}
	}, []);

	const value = useMemo(() => ({ selectedModule, setSelectedModule }), [selectedModule, setSelectedModule]);

	return <ModuleFilterContext.Provider value={value}>{children}</ModuleFilterContext.Provider>;
};

export default ModuleFilterProvider;
